import { useEffect } from 'react';

export const useResizeText = () => {
  const isOverflown = ({ offsetWidth, scrollWidth }: HTMLElement) => {
    return scrollWidth > offsetWidth;
  };

  const resizeText = ({ element, parent }: { element: HTMLElement; parent: HTMLElement }) => {
    let i = 1;
    let overflow = false;
    const maxSize = 3.1;

    while (!overflow && i < maxSize) {
      element.style.fontSize = `${i}rem`;
      overflow = isOverflown(parent);
      if (!overflow) i = i + 0.1;
    }

    // revert to last state where no overflow happened:
    element.style.fontSize = `${i - 0.1}rem`;
  };

  useEffect(() => {
    if (document.getElementById('currency') && document.getElementById('account-container')) {
      resizeText({
        element: document.getElementById('currency')!,
        parent: document.getElementById('account-container')!
      });
    }
  }, []);

  return { resizeText };
};
